var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-banner",attrs:{"flex":"main:center cross:top","flex-box":"0"}},[_c('div',{staticStyle:{"margin-right":"auto"}},[_c('p',[_vm._t("t1")],2),_c('span',[_vm._t("t2")],2)]),_vm._t("img")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }